import { render, staticRenderFns } from "./AppExpansionPanel.vue?vue&type=template&id=4802e426&scoped=true&"
import script from "./AppExpansionPanel.vue?vue&type=script&lang=ts&"
export * from "./AppExpansionPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AppExpansionPanel.vue?vue&type=style&index=0&id=4802e426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4802e426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel})
